/**
 * /admin/partner-earnings — Partner programme earnings (route shell).
 * Screen impl in `./partner-earnings-screen.tsx`, lazy-loaded.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/partner-earnings')({
  component: lazyRouteComponent(
    () => import('./partner-earnings-screen'),
    'AdminPartnerEarnings',
  ),
});
